import React from "react";
import { ExternalLink } from "lucide-react";
import { formatHungarianDateTime } from "../utils";

interface HeaderProps {
  lastUpdated: Date | null;
}

export const Header: React.FC<HeaderProps> = ({ lastUpdated }) => {
  return (
    <header className="bg-white border-b border-[#dedbd4] sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        {/* Left: Official Brand Lockup */}
        <div className="flex items-center gap-3.5">
          <a href="/" className="inline-flex items-center">
            <img
              src="/logo-legalease.svg"
              alt="LegalEase"
              className="h-9 w-auto"
            />
          </a>

          <div className="h-5 w-px bg-[#dedbd4] hidden sm:block" />

          <div className="hidden sm:flex items-center">
            <span className="text-sm font-semibold text-[#1b2a47] tracking-tight">
              Rendszerállapot
            </span>
          </div>
        </div>

        {/* Right: Controls & Actions */}
        <div className="flex items-center gap-4">
          {/* Last Updated Timestamp */}
          <div className="flex items-center gap-2">
            <span
              className={`w-2 h-2 rounded-full ${lastUpdated ? "bg-[#246047]" : "bg-[#dedbd4]"}`}
            />
            <span className="text-xs text-[#62666b]">
              Frissítve:{" "}
              <span className="text-[#1b2a47] font-mono font-medium">
                {lastUpdated ? formatHungarianDateTime(lastUpdated).slice(12) : "–"}
              </span>
            </span>
          </div>

          {/* Link to Main App */}
          <a
            href="/"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-[#1b2a47] bg-white hover:bg-[#f3f1ec] border border-[#8c8982] rounded-[0.375rem] transition-colors"
          >
            <span>LegalEase</span>
            <ExternalLink className="w-3.5 h-3.5 text-[#62666b]" />
          </a>
        </div>
      </div>
    </header>
  );
};
